import React, { useEffect, useState } from 'react'
import './LoginPage.css'
import FactoryLogo from '../Assets/LogoImg1.png'
import heroSection from '../Assets/heroSection1.png'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Modal, Input, Button, Typography, Select } from 'antd'
import { VscDebugBreakpointData } from 'react-icons/vsc'
import { MailOutlined, LockOutlined } from '@ant-design/icons'
import { AdminLoginAPI, YearListAPI } from '../AllAPI/AdminAPI'

export default function AdminLoginPage({ onLogin }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [year, setYear] = useState(null)
  const [yearList, setYearList] = useState([])
  const [yearLoading, setYearLoading] = useState(false)

  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [showLogin, setShowLogin] = useState(false)

  useEffect(() => {
    if (showLogin) {
      fetchYears()
    }
  }, [showLogin])

  // const fetchYears = async () => {
  //   setYearLoading(true)
  //   try {
  //     const res = await axios.get(YearListAPI)
  //     const data = res.data

  //     const formatted = Array.isArray(data)
  //       ? data.map((y) => (typeof y === 'number' ? y : y.year))
  //       : []

  //     setYearList(formatted)
  //   } catch (err) {
  //     toast.error('Failed to load years')
  //     console.error(err)
  //   } finally {
  //     setYearLoading(false)
  //   }
  // }

  const fetchYears = async () => {
  setYearLoading(true)
  try {
    const res = await axios.get(YearListAPI)
    const data = res.data

    const formatted = Array.isArray(data)
      ? data.map((y) => (typeof y === 'number' ? y : y.year))
      : []

    setYearList(formatted)

    // ✅ set first year as default
    if (formatted.length > 0) {
      setYear(formatted[0])
    }
  } catch (err) {
    toast.error('Failed to load years')
    console.error(err)
  } finally {
    setYearLoading(false)
  }
}


  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!year) {
      toast.warn('Please select year')
      return
    }

    if (!username || !password) {
      toast.error('Please enter both username and password')
      return
    }

    setLoading(true)

    try {
      const res = await axios.post(AdminLoginAPI, {
        username,
        password,
      })

      setLoading(false)

      const data = res.data
      console.log('LOGIN RESPONSE:', data)

      // Case 1: API returns string responses
      if (typeof data === 'string') {
        const response = data.trim().toUpperCase()

        if (response === 'REQUIRED') {
          toast.warn('All fields required!')
        } else if (response === 'INVALID') {
          toast.error('Invalid username or password!')
        } else if (response === 'ERROR') {
          toast.error('Server error!')
        } else {
          toast.error('Unexpected response from server')
        }
        return
      }

      // Case 2: API returns object (SUCCESS)
      if (data.username && data.role !== null) {
        toast.success('Login successful!')

        // Save in sessionStorage
        sessionStorage.setItem('username', data.username)
        sessionStorage.setItem('role', data.role)

        //  auth token
        sessionStorage.setItem('adminAuth', data.token)
        // year
        sessionStorage.setItem('year', year)

        setShowLogin(false)
        navigate('/dashboard')
      } else {
        toast.error('Invalid response structure')
      }
    } catch (error) {
      setLoading(false)
      toast.error('Something went wrong. Please try again.')
      console.error('Error:', error)
    }
  }

  return (
    <div className="login-background" style={{ backgroundColor: 'whitesmoke' }}>
      <div className="row m-0">
        <div className="marquee-wrapper">
          <div className="marquee">
            <span>
              📢 Important Notice: We do not provide home delivery services. All
              orders must be collected directly from our Sangli store.
            </span>
          </div>
        </div>

        {/* TOP LEFT HEADER */}
        <div
          className="col-12"
          style={{
            boxShadow: '0 4px 6px -2px rgba(0,0,0,0.4)',
            zIndex: '1000',
          }}
        >
          <div className="row m-0 p-0 align-items-center pb-2 pb-md-0">
            <div className="col-3 col-md-1 col-xl-1 text-center p-0">
              <img
                src={FactoryLogo}
                alt="Company Logo"
                className="footer-logo"
              />
            </div>

            <div className="col-9 col-md-8 col-xl-9 text-start">
              <h3
                style={{ textShadow: '1px 1px 2px #c3a07e', color: '#f32d02' }}
                className="company-name"
              >
                SHREE GANESH ARTS FACTORY
              </h3>
            </div>

            {/* MENU ICON */}
            <div className="col-12 col-md-3 col-xl-2 text-center">
              <Button
                size="large"
                block
                style={{
                  backgroundColor: '#011627',
                  color: 'white',
                  width: '160px',
                }}
                onClick={() => {
                  setShowLogin(true)
                }}
              >
                Admin Login
              </Button>
            </div>
          </div>
        </div>

        {/* LOGIN MODAL */}
        <Modal
          open={showLogin}
          onCancel={() => setShowLogin(false)}
          footer={null}
          centered
          width={380}
        >
          <form onSubmit={handleSubmit}>
            <Typography.Title level={4} style={{ textAlign: 'center' }}>
              Admin Login
            </Typography.Title>

            <Input
              size="large"
              placeholder="Username"
              prefix={<MailOutlined />}
              className="mb-3"
              onChange={(e) => setUsername(e.target.value)}
              value={username}
            />

            <Input.Password
              size="large"
              placeholder="Password"
              prefix={<LockOutlined />}
              className="mb-3"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />

            <Select
              size="large"
              className="mb-3 w-100"
              placeholder="Select Year"
              value={year}
              onChange={(value) => setYear(value)}
              loading={yearLoading}
              allowClear
            >
              {yearList.map((y) => (
                <Select.Option key={y} value={y}>
                  {y}
                </Select.Option>
              ))}
            </Select>

            <Button
              size="large"
              block
              htmlType="submit"
              loading={loading}
              disabled={!year}
              style={{
                marginTop: 10,
                backgroundColor: year ? '#011627' : '#999',
                color: 'white',
              }}
            >
              Login
            </Button>
          </form>
        </Modal>

        {/* HERO SECTION */}
        <div className="col-12 p-0 m-0">
          <div className="hero-container">
            <img src={heroSection} alt="Hero" className="hero-img" />
          </div>
        </div>

        {/* FOOTER */}
        <div className="col-12">
          <footer className="footer row px-2 px-md-5">
            <div className="col-12 col-md-1"></div>
            <div className="col-12 col-md-10 px-2 px-md-5">
              <div className="row m-0 p-0 footer-container">
                {/* LEFT */}
                <div className="col-12 col-md-5 mt-3 mt-md-0 footer-left">
                  <h4 className="text-white pb-2">Location</h4>
                  <p>
                    <span>Ganesh Factory</span>
                  </p>
                  <p>
                    <span>Kupwad MIDC, Kupwad, Sangli 416416</span>
                  </p>
                </div>

                {/* CENTER */}
                <div className="col-12 col-md-3 mt-3 mt-md-0 footer-center">
                  <h4 className="text-white pb-2">Services</h4>
                  <p>
                    <span
                      className="textHover"
                      onClick={() => navigate('/')}
                      style={{ cursor: 'pointer' }}
                    >
                      <VscDebugBreakpointData /> Terms & Conditions
                    </span>
                  </p>
                  <p>
                    <span
                      className="textHover"
                      onClick={() => navigate('/')}
                      style={{ cursor: 'pointer' }}
                    >
                      <VscDebugBreakpointData /> Privacy Policy
                    </span>
                  </p>
                  <p>
                    <span
                      className="textHover"
                      onClick={() => navigate('/')}
                      style={{ cursor: 'pointer' }}
                    >
                      <VscDebugBreakpointData /> Cancellation & Refund Policy
                    </span>
                  </p>
                </div>

                {/* RIGHT */}
                <div className="col-12 col-md-4 mt-3 mt-md-0 footer-right">
                  <h4 className="text-white pb-2">Contact</h4>
                  <p>
                    <span> Call or email us for any queries</span>
                  </p>

                  <p>
                    <span className="textHover" style={{ cursor: 'pointer' }}>
                      <VscDebugBreakpointData /> +91 7022691008
                    </span>
                  </p>
                  <p>
                    <span className="textHover" style={{ cursor: 'pointer' }}>
                      <VscDebugBreakpointData /> +91 9480448108
                    </span>
                  </p>
                  <p>
                    <span className="textHover" style={{ cursor: 'pointer' }}>
                      <VscDebugBreakpointData /> ganeshfactory@gmail.com
                    </span>
                  </p>
                </div>
              </div>

              <div className="footer-bottom">
                © 2026 Shree Ganesh Arts Factory | Managed By TechnoAarv
                Solution
              </div>
            </div>
            <div className="col-12 col-md-1"></div>
          </footer>
        </div>
      </div>
    </div>
  )
}
